<template>
    <div>
        <div class="form-group">
            <label>Emails</label>
            <input type="text" class="form-control" v-model="data.emails">
        </div>
        <div class="form-group">
            <label>Email subject (Multi-Carrier)</label>
            <input type="text" class="form-control" v-model="data.subject_mc" placeholder="TruckersReport Jobs Driver Match">
        </div>
        <div class="form-group">
            <label>Email subject (JobAdviser)</label>
            <input type="text" class="form-control" v-model="data.subject_ja" placeholder="Direct Lead - HOT Job Adviser lead">
        </div>
        <div class="form-group">
            <label>Email subject other direct (Job Board, DE, ExactMatch)</label>
            <input type="text" class="form-control" v-model="data.subject_direct" placeholder="Direct Lead Received - TruckersReport Jobs">
        </div>

        <p class="pt-10" style="font-size:12px">Use shortcode <code>{app-type}</code> to get one of: (MC, Direct, ExactMatch, JobAdviser, DriverEngage)</p>
        <p class="pt-10" style="font-size:12px">Use shortcode <code>{campaign}</code> to get campaign name.</p>
    </div>
</template>

<script>
export default {
    components: {},
    props: [
        'data'
    ],
    data() {
        return {
        };
    }
}
</script>
